export type InputWithUnitOption = {
  value: string
  label: string
}

export type InputWithUnitPreviewState =
  | 'default'
  | 'focused'
  | 'filled'
  | 'disabled'
  | 'error'
  | 'unit-open'
  | 'optional'
  | 'with-info'

export const INPUT_WITH_UNIT_PREVIEW_STATES: InputWithUnitPreviewState[] = [
  'default',
  'focused',
  'filled',
  'disabled',
  'error',
  'unit-open',
  'optional',
  'with-info',
]

export const INPUT_WITH_UNIT_PREVIEW_STATE_LABELS: Record<
  InputWithUnitPreviewState,
  string
> = {
  default: 'Default',
  focused: 'Focused',
  filled: 'Filled',
  disabled: 'Disabled',
  error: 'Error',
  'unit-open': 'Unit open',
  optional: 'Optional',
  'with-info': 'With info',
}

export const INPUT_WITH_UNIT_DEMO_LABEL = 'Quantity'
export const INPUT_WITH_UNIT_DEMO_PLACEHOLDER = '0'
export const INPUT_WITH_UNIT_DEMO_VALUE = '250'
export const INPUT_WITH_UNIT_DEMO_ERROR_MESSAGE = 'Enter a valid quantity'
export const INPUT_WITH_UNIT_DEMO_INFO_MESSAGE = 'Choose a unit for this value'

export const INPUT_WITH_UNIT_DEMO_UNITS: InputWithUnitOption[] = [
  { value: 'mg', label: 'mg' },
  { value: 'g', label: 'g' },
  { value: 'ml', label: 'ml' },
  { value: 'L', label: 'L' },
  { value: '%', label: '%' },
]

export type InputWithUnitProps = {
  label?: string
  placeholder?: string
  value?: string
  defaultValue?: string
  unit?: string
  defaultUnit?: string
  units?: InputWithUnitOption[]
  disabled?: boolean
  error?: boolean
  helperText?: string
  optional?: boolean
  /** Dark surface styling. */
  darkMode?: boolean
  className?: string
  /** Static visual state for the design-system showcase only. */
  previewState?: InputWithUnitPreviewState
  onChange?: (value: string) => void
  onUnitChange?: (unit: string) => void
}
